import React, { Fragment } from 'react'
import Spinner from '../Spiner/Spiner'

const Button = ({
  label,
  children,
  disabled = false,
  width = 'fit',
  color = 'prime',
  isLoading = false,
  className,
  ...rest
}) => {
  return (
    <button
      {...rest}
      disabled={disabled}
      className={`w-${width}  font-medium px-4 py-3 rounded-lg text-center disabled:pointer-events-none disabled:cursor-auto disabled:bg-opacity-80 ${
        children ? 'flex gap-1.5 items-center justify-center' : ''
      } ${className}`}
    >
      {isLoading ? (
        <div className='flex gap-2'>
          <Spinner color='#fff' />
          <span>{label}</span>
        </div>
      ) : (
        <>
          {children && <span>{children}</span>}
          <span>{label}</span>
        </>
      )}
    </button>
  )
}

export default Button
